// makes it easier to mock out navigation in tests
export default function navigateToPath(path: string) {
  window.location.href = path;
}
